/**
 * Helpers for comparing action editor draft state against the saved snapshot.
 */

const UI_ONLY_KEYS = new Set(['tagInput', 'activeTab', 'createMode']);

export function normalizeDraftValue(value) {
  if (value === undefined || value === null) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return value;
  if (Array.isArray(value)) {
    return value.map((item) => normalizeDraftValue(item));
  }
  if (typeof value === 'object') {
    return Object.keys(value)
      .sort()
      .reduce((acc, key) => {
        if (UI_ONLY_KEYS.has(key)) return acc;
        acc[key] = normalizeDraftValue(value[key]);
        return acc;
      }, {});
  }
  return value;
}

export function normalizeActionDraft(draft) {
  if (!draft) return {};
  return normalizeDraftValue(draft);
}

export function hasActionDraftChanged(original, draft) {
  if (!original && !draft) return false;
  if (!original || !draft) return true;
  return JSON.stringify(normalizeActionDraft(original))
    !== JSON.stringify(normalizeActionDraft(draft));
}

export function buildEmailActionDraftFromStep(step) {
  const cfg = step?.config || {};
  return normalizeActionDraft({
    actionName: cfg.actionName || cfg.name || step?.name || '',
    fromName: cfg.fromName || cfg.from_name || '',
    fromEmail: cfg.fromEmail || cfg.from_email || '',
    replyTo: cfg.replyTo || cfg.reply_to || '',
    to: cfg.to || '{{contact.email}}',
    cc: cfg.cc || '',
    bcc: cfg.bcc || '',
    subject: cfg.subject || '',
    preheader: cfg.preheader || '',
    body: cfg.body || cfg.body_html || '',
    bodyHtml: cfg.body_html || cfg.body || '',
    templateId: cfg.templateId || '',
    trackClicks: cfg.trackClicks !== false,
    utmTracking: cfg.utmTracking || false,
    utmSource: cfg.utmSource || '',
    utmMedium: cfg.utmMedium || 'email',
    utmCampaign: cfg.utmCampaign || '',
    addTags: cfg.addTags || [],
    attachments: cfg.attachments || [],
  });
}

export function buildEmailActionDraftFromConfig(config) {
  return normalizeActionDraft({
    actionName: config.actionName,
    fromName: config.fromName,
    fromEmail: config.fromEmail,
    replyTo: config.replyTo,
    to: config.to,
    cc: config.cc,
    bcc: config.bcc,
    subject: config.subject,
    preheader: config.preheader,
    body: config.body,
    bodyHtml: config.bodyHtml,
    templateId: config.templateId,
    trackClicks: config.trackClicks !== false,
    utmTracking: config.utmTracking || false,
    utmSource: config.utmSource || '',
    utmMedium: config.utmMedium || 'email',
    utmCampaign: config.utmCampaign || '',
    addTags: config.addTags || [],
    attachments: config.attachments || [],
  });
}

export function buildStepConfigDraft(step) {
  return normalizeActionDraft(step?.config || {});
}
